import React from 'react'
import { useLocation } from 'react-router-dom'
import { translate } from 'locales'
import {
  CalendarToday,
  Dashboard as DashboardIcon,
  People,
  AssignmentTurnedIn,
  HelpOutline,
  AttachMoney,
} from '@mui/icons-material'
import './styles.scss'

const Menu: React.FC<{
  openNewTab?: boolean
  setClickedRoute: React.Dispatch<React.SetStateAction<string>>
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  redirect: (route: string) => void
}> = ({ openNewTab = false, setClickedRoute, setShowModal, redirect }) => {
  const { pathname } = useLocation()

  // const changeSelect = (item: string) => {
  //   window.localStorage.setItem('@StarBem:lang', item)
  //   window.location.reload()
  // }

  const handleClicked = (route: string) => {
    setClickedRoute(route)
    setShowModal(true)
  }

  const go = (route: string) =>
    openNewTab ? handleClicked(route) : redirect(route)

  return (
    <nav id="menu">
      <ul>
        <li>
          <a
            className={pathname === '/dashboard' ? 'active' : ''}
            onClick={() => go('/dashboard')}
          >
            <CalendarToday className="menu-icon" fontSize="medium" />
            <span>{translate('header.schedule')}</span>
          </a>
        </li>
        <div className="menu-divider" />
        <li>
          <a
            className={pathname === '/dash' ? 'active' : ''}
            onClick={() => go('/dash')}
          >
            <DashboardIcon className="menu-icon" fontSize="medium" />
            <span>Dashboard</span>
          </a>
        </li>
        <div className="menu-divider" />
        <li>
          <a
            className={pathname === '/pacientes' ? 'active' : ''}
            onClick={() => go('/pacientes')}
          >
            <People className="menu-icon" fontSize="medium" />
            <span>{translate('header.attendedPatients')}</span>
          </a>
        </li>
        <div className="menu-divider" />
        <li>
          <a
            className={pathname === '/financeiro' ? 'active' : ''}
            onClick={() => go('/financeiro')}
          >
            <AttachMoney className="menu-icon" fontSize="medium" />
            <span>{translate('header.financial')}</span>
          </a>
        </li>
        <div className="menu-divider" />
        <li>
          <a
            className={pathname === '/avaliados' ? 'active' : ''}
            onClick={() => go('/avaliados')}
          >
            <AssignmentTurnedIn className="menu-icon" fontSize="medium" />
            <span>{translate('header.evaluatedServices')}</span>
          </a>
        </li>
        <li>
          <a
            className={pathname === '/faq' ? 'active' : ''}
            onClick={() => go('/faq')}
          >
            <HelpOutline className="menu-icon" fontSize="medium" />
            <span>FAQ</span>
          </a>
        </li>
      </ul>
      {/* <div>
        <select
          name="locales"
          title="locales"
          id="locales"
          value={
            window.localStorage.getItem('@StarBem:lang') === 'en' ? 'en' : 'pt'
          }
          onChange={(e) => changeSelect(e.target.value)}
        >
          <option value="pt">🇧🇷 PT</option>
          <option value="en">🇺🇸 EN</option>
        </select>
      </div> */}
    </nav>
  )
}

export default Menu
